/**
 * MIRA Separator Component
 * Wraps Shadcn Separator with MIRA design system styles
 */

import React from 'react';
import { Separator as ShadcnSeparator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/separator.module.css';

export const Separator = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSeparator
        ref={ref}
        className={cn(styles.miraSeparator, className)}
        {...props}
      />
    );
  }
);

Separator.displayName = 'MiraSeparator';
